import { getRailsClient } from "../client";

import { Resource } from "./types/lessonTypes";

interface ResourcesResponse {
  userResources: Resource[];
  customResources: Resource[];
}

export const fetchLessonResources = async (lessonId: number) => {
  const client = getRailsClient();
  const URL = `/api/internal_api/v1/levels/undefined/lessons/${lessonId}/resources`;
  const response = await client.get<ResourcesResponse>(URL);
  const { customResources } = response.data;
  return customResources;
};
